import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const TaIndicatorConfig = React.lazy(() =>
    import('../TaIndicatorConfig')
);
const taIndicatorConfigRoutesRegistry = [
    {
        path: PAGE_URL.TA_INDICATOR_CONFIG_PAGE,
        element: <TaIndicatorConfig />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default taIndicatorConfigRoutesRegistry;
